import { render, staticRenderFns } from "./TvaParallax.vue?vue&type=template&id=2faf9cfa&scoped=true&"
import script from "./TvaParallax.vue?vue&type=script&lang=js&"
export * from "./TvaParallax.vue?vue&type=script&lang=js&"
import style0 from "./TvaParallax.vue?vue&type=style&index=0&id=2faf9cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faf9cfa",
  null
  
)

export default component.exports